import { render, staticRenderFns } from "./BtnStatusDocumento.vue?vue&type=template&id=460fc798&"
import script from "./BtnStatusDocumento.vue?vue&type=script&lang=js&"
export * from "./BtnStatusDocumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports